module.exports = __webpack_public_path__ + "static/media/Acceptance-Graphic.b279214b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Acceptance-Graphic.png
// module id = 296
// module chunks = 17